import React from "react";
import { Link } from "react-router-dom";
import { Card, Grid, Icon } from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import config from "config/configProvider";

interface FormLink {
  title: string;
  description: string;
  icon: string;
  color: string;
  route: string;
  enabled: boolean;
}

const formLinks: FormLink[] = [
  {
    title: "Vehicle Service Update",
    description: "Update vehicle service and maintenance records",
    icon: "build",
    color: "secondary",
    route: "/forms/vehicle-service-update",
    enabled: config.FormsEnabled_VehicleServiceUpdate === "true",
  },
  {
    title: "Overtime Request",
    description: "Submit overtime authorization requests",
    icon: "more_time",
    color: "warning",
    route: "/forms/overtime-request",
    enabled: config.FormsEnabled_OvertimeRequest === "true",
  },
  {
    title: "Receipt Submission",
    description: "Rapid Card receipt submissions",
    icon: "receipt",
    color: "error",
    route: "/forms/receipt-submission",
    enabled: config.FormsEnabled_ReceiptSubmission === "true",
  },
  {
    title: "Fuel Card",
    description: "Fuel card actions (reset/replace/purchase)",
    icon: "credit_card",
    color: "info",
    route: "/forms/fuel-card",
    enabled: config.FormsEnabled_FuelCard === "true",
  },
  {
    title: "Ride Along",
    description: "Pre-employment ride along evaluations",
    icon: "person_search",
    color: "primary",
    route: "/forms/ride-along",
    enabled: config.FormsEnabled_RideAlong === "true",
  },
  {
    title: "Shift Closing",
    description: "Location manager shift closing",
    icon: "assignment_turned_in",
    color: "success",
    route: "/forms/shift-closing",
    enabled: config.FormsEnabled_ShiftClosing === "true",
  },
  {
    title: "Shift Overlap Authorization",
    description: "Closing - shift overlap authorization",
    icon: "schedule",
    color: "warning",
    route: "/forms/shift-overlap-authorization",
    enabled: config.FormsEnabled_ShiftOverlapAuthorization === "true",
  },
];

const FormsList = () => {
  return (
    <MDBox>
      <MDBox mb={3}>
        <MDTypography variant="h5" fontWeight="medium">
          Forms
        </MDTypography>
        <MDTypography variant="body2" color="text">
          Select a form to get started
        </MDTypography>
      </MDBox>
      <Grid container spacing={3}>
        {formLinks.filter((form) => form.enabled).map((form) => (
          <Grid item xs={12} sm={6} md={4} key={form.title}>
            <Card
              component={Link}
              to={form.route}
              sx={{
                textDecoration: "none",
                transition: "transform 0.2s, box-shadow 0.2s",
                "&:hover": {
                  transform: "translateY(-4px)",
                  boxShadow: 6,
                },
              }}
            >
              <MDBox p={3}>
                <MDBox display="flex" alignItems="center" mb={2}>
                  <MDBox
                    variant="gradient"
                    bgColor={form.color}
                    color="white"
                    coloredShadow={form.color}
                    borderRadius="lg"
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    width="3rem"
                    height="3rem"
                  >
                    <Icon fontSize="medium">{form.icon}</Icon>
                  </MDBox>
                  <MDBox ml={2}>
                    <MDTypography variant="h6" fontWeight="medium">
                      {form.title}
                    </MDTypography>
                  </MDBox>
                </MDBox>
                <MDTypography variant="body2" color="text">
                  {form.description}
                </MDTypography>
              </MDBox>
            </Card>
          </Grid>
        ))}
      </Grid>
    </MDBox>
  );
};

export default FormsList;
